module.exports = __webpack_public_path__ + "img/fw3.ae619938.png";